import { Action } from 'redux';
import { LocationChangeAction } from 'connected-react-router';
import { CopiesListSuccessPayload } from './state';
import { ErrorAction } from '../index';

export const COPIES_LIST_REQUEST = 'COPIES_LIST_REQUEST';
export const COPIES_LIST_SUCCESS = 'COPIES_LIST_SUCCESS';
export const COPIES_LIST_USAGE_CONDITIONS_UPDATE = 'COPIES_LIST_USAGE_CONDITIONS_UPDATE';
export const COPIES_LIST_FAILURE = 'COPIES_LIST_FAILURE';
export const COPIES_LIST_RESET = 'COPIES_LIST_RESET';

export type CopiesListRequest = Action<typeof COPIES_LIST_REQUEST>;
export type CopiesListSuccess = {
    type: typeof COPIES_LIST_SUCCESS;
    payload: CopiesListSuccessPayload;
};
export type CopiesListUpdateUsageConditions = {
    type: typeof COPIES_LIST_USAGE_CONDITIONS_UPDATE;
    payload: string[];
};
export type CopiesListFailure = ErrorAction<typeof COPIES_LIST_FAILURE>;
export type CopiesListReset = Action<typeof COPIES_LIST_RESET>;

export type CopiesListAction =
    | CopiesListRequest
    | CopiesListSuccess
    | CopiesListUpdateUsageConditions
    | CopiesListFailure
    | CopiesListReset
    | LocationChangeAction;
